// Environment variables configuration
const publishableKey = process.env.STRIPE_PUBLISHABLE_KEY;

export const config = {
  stripe: {
    publishableKey: publishableKey,
  },
  api: {
    baseUrl: process.env.BFF_URL,
    endpoints: {
      setupIntent: '/payment/setup-intent',
      paymentMethods: '/payment/methods'
    }
  }
};
